import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=61e82972&"
import script from "./Conclusion.vue?vue&type=script&lang=js&"
export * from "./Conclusion.vue?vue&type=script&lang=js&"
import style0 from "./Conclusion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports